import { useNavigate, useLocation } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { SystemInvoiceTable } from './system_invoice_table.component';
import styles from '../POWorkflowManagement/po_workflow_management.module.css';

export const SystemInvoicePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { poNumber, invoices, poDetails } = location.state || {
    poNumber: '',
    invoices: [],
    poDetails: null,
  };

  const handleBackClick = () => {
    navigate('/systemPoWorkflowManagement');
  };

  return (
    <DashboardLayout padding={true}>
      <div className={styles['po-workflow-container']}>
        <div className={styles['po-workflow-header']}>
          <div className={styles['header-left']}>
            <div className={styles['back-icon-container']} onClick={handleBackClick}>
              <ArrowBackIosOutlinedIcon className={styles['back-icon']} />
            </div>
            <h1 className={styles['page-title']}>{poNumber || 'Invoice Details'}</h1>
          </div>
        </div>

        <SystemInvoiceTable poNumber={poNumber} invoices={invoices} poDetails={poDetails} />
      </div>
    </DashboardLayout>
  );
};
